__turbopack_context__.v({
  "block": "LIZRba_block",
  "channel": "LIZRba_channel",
  "channelHead": "LIZRba_channelHead",
  "channelLead": "LIZRba_channelLead",
  "channelNote": "LIZRba_channelNote",
  "channelScore": "LIZRba_channelScore",
  "channelTitle": "LIZRba_channelTitle",
  "composite": "LIZRba_composite",
  "compositeBand": "LIZRba_compositeBand",
  "compositeLabel": "LIZRba_compositeLabel",
  "compositeValue": "LIZRba_compositeValue",
  "finding": "LIZRba_finding",
  "findingBody": "LIZRba_findingBody",
  "findingFix": "LIZRba_findingFix",
  "findingHead": "LIZRba_findingHead",
  "findingTitle": "LIZRba_findingTitle",
  "findings": "LIZRba_findings",
  "head": "LIZRba_head",
  "headline": "LIZRba_headline",
  "label": "LIZRba_label",
  "lead": "LIZRba_lead",
  "meter": "LIZRba_meter",
  "meterFill": "LIZRba_meterFill",
  "note": "LIZRba_note",
  "row": "LIZRba_row",
  "rowBand": "LIZRba_rowBand",
  "rowName": "LIZRba_rowName",
  "rowNotAssessed": "LIZRba_rowNotAssessed",
  "rowScore": "LIZRba_rowScore",
  "rows": "LIZRba_rows",
  "strengths": "LIZRba_strengths",
  "strengthsLabel": "LIZRba_strengthsLabel",
  "vital": "LIZRba_vital",
  "vitalNote": "LIZRba_vitalNote",
  "vitals": "LIZRba_vitals",
});
